import React from "react";

export const Shell = ({ eyebrow, title, intro, children, max = "max-w-4xl" }) => (
    <div className={`${max} mx-auto px-4 sm:px-8 py-14 lg:py-20`}>
        {eyebrow && <p className="uppercase tracking-[0.18em] text-xs font-semibold text-sage">{eyebrow}</p>}
        <h1 className="mt-3 text-4xl sm:text-5xl text-charcoal leading-tight">{title}</h1>
        {intro && <p className="mt-4 text-lg text-charcoal/75 max-w-2xl leading-relaxed">{intro}</p>}
        <div className="mt-10">{children}</div>
    </div>
);

export default Shell;
